export default function Eyebrow({ className = '', children }) {
  return <p className={`eyebrow ${className}`}>{children}</p>;
}
